import React from "react";
import { useNavigate } from "react-router-dom";
import PortalSidebar from "../components/PortalSidebar.tsx";
import { buildIdmUrl } from "../services/idmConfig.ts";
import "./overview.css";
import { useAuth } from "../AuthProvider.tsx";

const ACCOUNT_URL = buildIdmUrl("/realms/platform/account");

export default function Settings() {
  const navigate = useNavigate();
  const { isOrgAdmin, organization } = useAuth();

  return (
    <div className="portal-root">
      <PortalSidebar />
      <main className="portal-main">
        <div className="portal-topbar">
          <div className="portal-title">Einstellungen</div>
        </div>
        <section className="portal-settings-grid">
          {isOrgAdmin && <button type="button" className="portal-settings-card" onClick={() => navigate("/settings/organization")}>
            <span className="portal-settings-label">{organization?.name || "Organisation"}</span>
            <span className="portal-settings-copy">Mitglieder und Einladungen verwalten.</span>
          </button>}
          <button
            type="button"
            className="portal-settings-card"
            onClick={() => (window.location.href = ACCOUNT_URL)}
          >
            <span className="portal-settings-label">Konto Einstellungen</span>
            <span className="portal-settings-copy">
              Verwalte Zugangsdaten, Rechnungs- und Kontaktinformationen im IDM-Portal.
            </span>
          </button>
          <button
            type="button"
            className="portal-settings-card"
            onClick={() => navigate("/settings/licenses")}
          >
            <span className="portal-settings-label">Rechtliches</span>
            <span className="portal-settings-copy">
              Alle verwendeten Open-Source-Komponenten und Lizenztexte im Überblick.
            </span>
          </button>
        </section>
      </main>
    </div>
  );
}
